import React from "react";
import TextImageBanner from "../../components/common/TextImageBanner";
import BlogGridCardSection from "../../components/UserComponents/blog/BlogGridCardSection";
import image from "../../Assets/Home/MainHome/home3.png"
const Blog = () => {
  return (
    <div>
      <TextImageBanner
        label="blog"
        bgImage={[
          `${image}`,
          `${image}`,
          `${image}`,
        ]}
      />
      <BlogGridCardSection />
    </div>
  );
};

export default Blog;
